import { ColorEnum } from '@/constants/color'
import {
    slideSize,
    slideVisibleHorizontalOffset,
} from '@/features/ui/inputs/components/Switch/constants'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SlideProps {
    checked: boolean
    disabled?: boolean
}

const Slide: FC<SlideProps> = ({ checked, disabled }) => {
    const { styles } = useStyles(stylesheet, { checked })

    return <View style={[styles.slide, styles.extraStyle(checked, disabled)]}></View>
}

const stylesheet = createStyleSheet({
    slide: {
        ...slideSize,
        borderRadius: 10,
        variants: {
            checked: {
                true: {
                    alignSelf: 'flex-start',
                    marginLeft: slideVisibleHorizontalOffset,
                },
                false: {
                    alignSelf: 'flex-end',
                    marginRight: slideVisibleHorizontalOffset,
                },
            },
        },
    },
    extraStyle: (checked, disabled) => {
        switch (true) {
            case !disabled && checked:
                return {
                    backgroundColor: ColorEnum.BRICK_600,
                }
            case !disabled && !checked:
                return {
                    backgroundColor: ColorEnum.GRAY_400,
                }
            case disabled && !checked:
                return {
                    backgroundColor: ColorEnum.GRAY_300,
                }
            case disabled && checked:
                return {
                    backgroundColor: ColorEnum.BRICK_200,
                }
            default:
                return {}
        }
    },
})

export default Slide
